import { css } from "lit";

export const ViewRouteStyles = css`
            :host {
                margin: 10px;
                display: block;
            }
            .container {
                display: flex;
                flex-direction: column;
                align-items: center;
                font-family: 'MaerskText';
            }
            .summary {
                display: grid;
                grid-auto-flow: column;
                grid-template-rows: repeat(10, 1fr);
                grid-template-columns: repeat(3, auto);
                gap: 15px;
                margin-bottom: 15px;
            }
            .center {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .value {
                max-width: 110px;
                text-align: center;
                color: var(--neutrals-grey-02, black);
                font-size: 18px;
            }
            .header {
                font-weight: bold;
                font-size: 16px;
            }
            .label {
                max-width: 110px;
                text-align: center;
                color: var(--neutrals-grey-04, grey);
                font-size: 10px;
            }
            #passagePlanBtn {
                position: relative;
                background: none;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                width: 100%;
                height: 56px;
                color: var(--neutrals-grey-02, black);
                fill: currentColor;
                font-family: 'MaerskText';
                font-size: 14px;
                outline: none;
                border-radius: 2.5px;
                border: 1px solid var(--neutrals-grey-06, grey);
            }
            #passagePlanBtn > svg {
                display: block;
                height: 14px;
                margin-right: 5px;
                fill: var(--neutrals-grey-02, black);
            }
            .planStatus {
                position: absolute;
                border-radius: 10px;
                border: 1px solid var(--approved-plan-color, green);
                color: var(--approved-plan-color, green);
                font-size: 10px;
                line-height: 14px;
                padding-right: 5px;
                padding-left: 5px;
                padding-top: 1px;
                padding-bottom: 1px;
                right: 15px;
                top: 50%;
                transform: translateY(-50%);
            }
            /* background with opacity */
            .planStatus::before {
                content: "";
                position: absolute;
                border-radius: inherit;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                background-color: currentColor;
                opacity: 0.07;
            }
            voyage-route-export {
                margin-top: 10px;
            }

            voyage-route-export {
                margin-top: 10px;
            }

            voyage-spinner {
                height: 28px;
                width: 28px;
                --voyage-spinner-bg-color: var(--neutrals-grey-08, grey);
                --voyage-spinner-stroke-width: 3px;
            }
            .calculating-container {
                display: grid;
                place-items: center;
                font-family: 'MaerskText';
                font-size: 14px;
            }
            
            .calculating-items {
                display: grid;
                grid-template-rows: auto auto;
                place-items: center;
            }
            
            .update-warning {
                font-size: 12px;
                text-align: left;
                width: 100%;
                margin-bottom: 15px;
                color: var(--neutrals-grey-04, grey);
            }
            `